import { DeliveryTypeCategory } from '@/features/orders/constants/app'
import { DeliveryPaymentMapping } from '@/features/pos/components/OrderFinalization/types'
import { sortDeliveryTypeCategoriesVisualOrder } from '@/features/pos/components/OrderFinalization/utils/sortDeliveryTypeCategoriesVisualOrder'
import { useMemo } from 'react'

export const useDeliveryTypeCategories = (
    deliveryPaymentMappings: DeliveryPaymentMapping[]
): DeliveryTypeCategory[] => {
    return useMemo(
        () =>
            sortDeliveryTypeCategoriesVisualOrder(
                deliveryPaymentMappings.map(({ deliveryTypeCategory }) => deliveryTypeCategory)
            ),
        [deliveryPaymentMappings]
    )
}
